module.exports = __webpack_public_path__ + "img/Ethiopia.88ecc624.png";